import React from 'react';
import Fade from '@material-ui/core/Fade';
import DateTime, { MONTH_YEAR } from '../../../../../../DateTime';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class OutOfPocketMax extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/10_max.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Meet your max</H2>

            <P>
              There's a max amount you'll have to pay out-of-pocket. Once you reach it, your{' '}
              insurance will... finally... fully cover your care.
            </P>

            <P>Putting off any doctor visits? Book them after hitting your max–they’ll be free.</P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default OutOfPocketMax;
